const k = (key) => `video_shooting.briefing.${key}`;

const residential = {
  1: {
    type: 'section',
    components: [
      {
        type: 'component',
        label: k('information'),
        component: 'Title',
      }, {
        type: 'component',
        label: k('shooting_info'),
        component: 'Note',
      }, {
        type: 'question-component',
        label: 'shared.additional_info',
        component: 'Input',
        key: 'otherInfo',
        keyLabel: 'shared.keys.other_info',
      }, {
        type: 'question-component',
        label: 'shared.upload_files',
        component: 'FileUploader',
        key: 'otherInfoAttachments',
        keyLabel: 'shared.keys.other_info_attachments',
      },
    ],
  },
};

export default { residential };
